import React, { useState, useEffect } from "react";
import { Table, Button, Input, Space, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import AddAgentForm from "./AddAgentForm";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../redux/AddAgent/actions";
import { current } from "@reduxjs/toolkit";
import decryptedModulesData from "../../../utils/decryptedModules";

const AddAgent = () => {
  const { modules: permissions, role } = decryptedModulesData();
  const [searchText, setSearchText] = useState("");
  const [visible, setVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();

  const agentPermission =
    (Array.isArray(permissions) &&
      permissions.find(
        (item) => item.module.toLowerCase() === "agent details",
      )) ||
    {};

  //console.log("agentPermission", agentPermission);

  // Add proper null checks and default empty array
  const { totalAllAgentsData = [], loading: reduxLoading } = useSelector(
    (state) => state?.AllAgentReducer || {},
  );

  useEffect(() => {
    dispatch(actions.getAllAgentsData());
  }, [dispatch]);

  // Add proper null checks for filtering
  const filteredData = (totalAllAgentsData || [])
    .filter((agent) => agent) // Ensure agent exists
    .filter(
      (agent) =>
        agent.agentName?.toLowerCase().includes(searchText.toLowerCase()) ||
        agent.agentId?.toLowerCase().includes(searchText.toLowerCase()) ||
        agent.debitAccountNumber
          ?.toLowerCase()
          .includes(searchText.toLowerCase()),
    );

  const tableData = filteredData.map((agent, index) => ({
    key: index + 1,
    ...agent,
    createdAt: agent.createdAt
      ? new Date(agent.createdAt).toLocaleString()
      : "-",
    updatedAt: agent.updatedAt
      ? new Date(agent.updatedAt).toLocaleString()
      : "-",
  }));

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 50,
    },
    {
      title: "Agent ID",
      dataIndex: "agentId",
      key: "agentId",
      ellipsis: true,
    },
    {
      title: "Agent Name",
      dataIndex: "agentName",
      key: "agentName",
    },
    {
      title: "Ai Identifier",
      dataIndex: "aiIdentifier",
      key: "aiIdentifier",
    },
    {
      title: "Current Balance",
      dataIndex: "currentBalance",
      key: "currentBalance",
      render: (text) =>
        text !== undefined && text !== null && text !== ""
          ? `${Number(text).toLocaleString("en-IN")}₹`
          : "_",
    },
    {
      title: "Credit Account (Bank)",
      dataIndex: "creditAccountNumber",
      key: "creditAccountNumber",
    },
    {
      title: "Debit Account",
      dataIndex: "debitAccountNumber",
      key: "debitAccountNumber",
    },
    {
      title: "Teller Branch",
      dataIndex: "tellerBranch",
      key: "tellerBranch",
    },
    {
      title: "Teller ID",
      dataIndex: "tellerID",
      key: "tellerID",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
    },
    {
      title: "ACTIONS",
      key: "actions",
      render: (_, record) => {
        const canUpdate = agentPermission?.update ?? false;

        return (
          <Space size="middle">
            <Button
              type="link"
              icon={
                <span role="img" aria-label="edit">
                  ✏️
                </span>
              }
              disabled={!canUpdate}
              onClick={() => {
                if (canUpdate) {
                  setEditingRecord(record);
                  setVisible(true);
                }
              }}
              style={{
                padding: 0,
                opacity: canUpdate ? 1 : 0.6, // dim if not allowed
                cursor: canUpdate ? "pointer" : "not-allowed",
              }}
            />
          </Space>
        );
      },
    },
  ];

  return (
    <div className="mainContain">
      {contextHolder}
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* <Button
          type="primary"
          size="large"
          onClick={() => {
            setEditingRecord(null);
            setVisible(true);
          }}
          style={{
            backgroundColor: "#073763",
            borderColor: "#073763",
          }}
        >
          Add Agent
        </Button> */}
        {agentPermission && (
          <Button
            type="primary"
            size="large"
            onClick={() => {
              if (agentPermission.create) {
                setEditingRecord(null);
                setVisible(true);
              }
            }}
            disabled={!agentPermission.create} // disable if no create permission
            style={{
              backgroundColor: "#073763",
              borderColor: "#073763",
              color: "white",
              opacity: agentPermission.create ? 1 : 0.6, // dim if disabled
              cursor: agentPermission.create ? "pointer" : "not-allowed",
            }}
          >
            Add Agent
          </Button>
        )}

        <Input
          placeholder="Search by ai"
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
      </div>

      <Table
        columns={columns}
        dataSource={tableData}
        loading={reduxLoading}
        bordered
        rowKey="_id"
        scroll={{ x: true }}
        pagination={{
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "100"],
          defaultPageSize: 100, // Added to ensure 100 rows by default
        }}
      />

      <AddAgentForm
        totalAllAgentsData={totalAllAgentsData}
        visible={visible}
        onCancel={() => {
          setEditingRecord(null);
          setVisible(false);
        }}
        editingRecord={editingRecord}
      />
    </div>
  );
};

export default AddAgent;
